import { addDays, format } from "date-fns";

import { DATE_FORMAT } from "../../dependencies/utils";
import type { NonEmptyArray } from "../../types";

export const DEFAULT_DATE = "week";

export const DEFAULT_REGULAR_DATES_TO_SHOW = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map(
  (day) => format(addDays(new Date(), day), DATE_FORMAT),
) as NonEmptyArray<string>;
